var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { reduxKey } from '../constants';
import { setSocialLoginError, initializeFacebookJSSDK } from './actions';
var initialState = {};
var handler = handleActions((_a = {},
    _a["".concat(setSocialLoginError)] = function (state, action) { return (__assign(__assign({}, state), { error: action.payload.errorCode })); },
    _a["".concat(initializeFacebookJSSDK)] = function (state, action) { return (__assign(__assign({}, state), { isFacebookSDKInitialized: true })); },
    _a), initialState);
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducer.js.map